import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalSearchResult } from '@wdx/clmi/clmi-swagger-gen';
import { PaginatedApiResponse } from '@wdx/clmi/api-services/models';
import { Observable } from 'rxjs';
import {
    EntityFiltersResult,
    GlobalSearchRequest,
} from '../../models/global-search.model';
import { PaginationOptions } from '../../models/pagination-options';
import { ApiPaginationService } from '@wdx/shared/infrastructure/api-service';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class GlobalSearchService {
    constructor(
        private http: HttpClient,
        private apiPaginationService: ApiPaginationService,
        private configService: ConfigService,
    ) {}

    getPage(
        searchRequest: GlobalSearchRequest,
        paginationOptions: PaginationOptions,
    ): Observable<PaginatedApiResponse<GlobalSearchResult>> {
        return this.http.post<PaginatedApiResponse<GlobalSearchResult>>(
            `${this.configService.getConfiguration().API_BASE}/search`,
            searchRequest,
            {
                headers:
                    this.apiPaginationService.mapPaginationOptions(
                        paginationOptions,
                    ),
            },
        );
    }

    getEntityFilters(): Observable<EntityFiltersResult[]> {
        return this.http.get<EntityFiltersResult[]>(
            `${
                this.configService.getConfiguration().API_BASE
            }/search/entityfilters`,
        );
    }
}
